import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {SliceStatus, UserImportStatus} from 'interfaces'
import {SettingsState} from '../settingsSlice'

const selectSettings = (state: RootState): SettingsState => {
  return state.settings
}

export const selectEndpointConfigState = createSelector(
  selectSettings,
  settings => settings?.endpointsConfig,
)

export const selectImportStatusState = createSelector(
  selectSettings,
  settings => settings?.importStatus,
)

export const selectImportLinkState = createSelector(
  selectSettings,
  settings => settings?.link,
)

export const selectShowLoadingState = createSelector(
  selectEndpointConfigState,
  selectImportStatusState,
  (endpointConfig, importStatus) =>
    endpointConfig?.status === SliceStatus.pending ||
    importStatus?.status === SliceStatus.pending,
)

export const selectUserImportStarted = createSelector(
  selectImportStatusState,
  importStatus =>
    importStatus?.data?.importStatus === UserImportStatus.IN_PROGRESS,
)

export const selectUserImportCompleted = createSelector(
  selectImportStatusState,
  importStatus => importStatus?.data?.importStatus === UserImportStatus.DONE,
)
